/**
 * Zero price cart guard
 * ----------------------
 * Elimina automaticamente del carrito cualquier linea cuyo precio actual
 * (tras recalcular contra el precio vigente de la variante) sea 0 euros.
 * Cubre el caso en el que el ERP devuelve precio 0 mientras la recepcion de
 * stock no esta dada de alta en almacen, y el cliente ya tenia el producto
 * en el carrito desde antes de que el precio cambiara.
 *
 * Se ejecuta en cada carga de pagina y cada vez que Shopify vuelve a
 * renderizar una seccion (editor de temas), asi que actua "en cualquier
 * URL de la web" tal y como se pidio.
 */
(function () {
  function removeZeroPriceLines() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

        var zeroPriceLines = cart.items.filter(function (item) {
          return item.final_price === 0;
        });

        if (zeroPriceLines.length === 0) return;

        removeSequentially(zeroPriceLines.slice());
      })
      .catch(function () {});
  }

  function removeSequentially(lines) {
    if (lines.length === 0) {
      notifyCartUpdated();
      showZeroPriceNotice();
      return;
    }

    var item = lines.shift();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }),
    })
      .catch(function () {})
      .then(function () {
        removeSequentially(lines);
      });
  }

  function notifyCartUpdated() {
    // Refresca el drawer/pagina de carrito reutilizando el mismo pub/sub
    // que ya usa el tema (cart.js, cart-drawer.js) para repintarse.
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zero-price-guard' });
    }
  }

  function showZeroPriceNotice() {
    if (document.getElementById('zero-price-guard-notice')) return;

    var notice = document.createElement('div');
    notice.id = 'zero-price-guard-notice';
    notice.setAttribute('role', 'status');
    notice.textContent =
      'Hemos eliminado de tu carrito un producto que estara disponible muy pronto.';
    notice.style.position = 'fixed';
    notice.style.bottom = '20px';
    notice.style.left = '50%';
    notice.style.transform = 'translateX(-50%)';
    notice.style.background = '#1a1a1a';
    notice.style.color = '#fff';
    notice.style.padding = '12px 20px';
    notice.style.borderRadius = '6px';
    notice.style.zIndex = '9999';
    notice.style.fontSize = '14px';
    notice.style.maxWidth = '90vw';
    notice.style.textAlign = 'center';
    notice.style.boxShadow = '0 2px 10px rgba(0,0,0,0.25)';

    document.body.appendChild(notice);
    setTimeout(function () {
      notice.remove();
    }, 6000);
  }

  document.addEventListener('DOMContentLoaded', removeZeroPriceLines);
  document.addEventListener('shopify:section:load', removeZeroPriceLines);
})();
